import { Console } from '../console/Console';
import { useBotOutlet } from '../botOutlet';

/** Owner entry point into the one Console (§7.3). No second implementation. */
export function OwnerConsoleRoute() {
  const { bot, caps, reload, rental } = useBotOutlet();
  return <Console bot={bot} caps={caps} reload={reload} scope="owner" rental={rental} />;
}
